<permission-checker [roles]="roles" (contentInit)="initContent()">
  <div class="content-holder">
    <mat-toolbar color="accent" class="page-toolbar" [class.mobile]="mobileView">
      <mat-toolbar-row class="toolbar-row">
        <h1 i18n="Contests List|Available Contests List title@@contests-list-available-title">Available Contests</h1>
      </mat-toolbar-row>
    </mat-toolbar>

    <div class="content page">
      <app-no-content *ngIf="competitions && !competitions.length"
                      [compact]="true"
                      title="There is no available competitions at the moment"
                      i18n-title="Contests List|No available competitions title@@contests-list-no-available-competitions-title"
                      details="Check again later to see whether competition becomes available"
                      i18n-details="Contests List|No available competitions details@@contests-list-no-available-competitions-details">
      </app-no-content>

      <mat-spinner *ngIf="!competitions" color="primary" diameter="50" class="center"></mat-spinner>

      <div *ngIf="competitions" fxLayout="row wrap" fxLayout.lt-md="column" class="full-width">
        <mat-card *ngFor="let competition of competitions" class="competitions-details-card"
                  fxFlex="48%"
                  fxFlex.lt-md="100%">
          <mat-card-header>
            <mat-card-title>{{competition.name}}</mat-card-title>
          </mat-card-header>
          <mat-card-subtitle>
            <app-link class="navigate-link"
                      icon="east"
                      label="To Competition"
                      i18n-label="Contests List|To Competition button title@@contests-list-to-competition-button-title"
                      (click)="navigateToCompetition(competition)"></app-link>
          </mat-card-subtitle>
          <mat-card-content>
            <mat-spinner *ngIf="!contests.has(competition.id)"
                         color="primary"
                         diameter="30"
                         class="center center-vertical"></mat-spinner>

            <img [src]="competition.logoUrl" [alt]="competition.name" class="competition-logo center">

            <app-no-content *ngIf="contests.has(competition.id) && !getContests(competition.id).length"
                            [compact]="true"
                            title="There is no available contests at the moment"
                            i18n-title="Contests List|No available contests title@@contests-list-no-available-contests-title">
            </app-no-content>

            <div *ngIf="contests.has(competition.id) && getContests(competition.id).length > 0">
              <div i18n="Contests List|Available contests title@@contests-list-available-contests-title"
                   class="available-contests-title">
                Available contests:
              </div>

              <mat-list class="list-container no-focus">
                <mat-list-item *ngFor="let contest of contests.get(competition.id)"
                               class="list-option no-focus">
                  <div class="list-item-content full-width" fxLayout="column">
                    <div class="contest-name">
                      <span>{{contest.name}}</span>
                      <span class="fill-space"></span>
                      <mat-icon *ngIf="!contest.paymentAt" class="color-green">maps_ugc</mat-icon>
                    </div>
                    <div class="mat-small">
                      <span class="text-disabled-color"
                            i18n="Contest Enrol Modal|Contest Enrol period section title@@contest-enrol-modal-period-section-title">
                        Period:
                      </span>
                      {{contest.startsAt | date: 'medium'}} - {{contest.endsAt | date: 'medium'}}
                    </div>
                  </div>
                </mat-list-item>
              </mat-list>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
</permission-checker>
